(() => {
  const host = document.querySelector('[data-wz-hero-3d]');
  const canvas = host?.querySelector('canvas');
  if (!host || !canvas) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const ctx = canvas.getContext('2d', { alpha: true });
  if (!ctx) {
    host.classList.add('wz-hero__3d--fallback');
    return;
  }

  let width = 0;
  let height = 0;
  let dpr = 1;
  let frame = 0;

  const resize = () => {
    const rect = host.getBoundingClientRect();
    dpr = Math.min(window.devicePixelRatio || 1, 1.75);
    width = Math.max(1, Math.round(rect.width));
    height = Math.max(1, Math.round(rect.height));
    canvas.width = Math.round(width * dpr);
    canvas.height = Math.round(height * dpr);
    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  };

  let isVisible = false;
  let animationFrame = 0;

  const draw = () => {
    ctx.clearRect(0, 0, width, height);

    const horizon = height * 0.46;
    const roadCenter = width * 0.7;
    const pulse = reduceMotion ? 0 : frame * 0.018;

    const glow = ctx.createRadialGradient(width * 0.78, height * 0.3, 20, width * 0.78, height * 0.3, width * 0.52);
    glow.addColorStop(0, 'rgba(18,184,176,0.3)');
    glow.addColorStop(0.48, 'rgba(18,184,176,0.08)');
    glow.addColorStop(1, 'rgba(18,184,176,0)');
    ctx.fillStyle = glow;
    ctx.fillRect(0, 0, width, height);

    ctx.save();
    ctx.translate(roadCenter, horizon);
    ctx.rotate(-0.16);
    for (let i = 0; i < 18; i += 1) {
      const t = i / 17;
      const y = t * height * 0.74;
      const half = 22 + t * width * 0.42;
      const alpha = 0.08 + t * 0.22;
      ctx.strokeStyle = `rgba(255,255,255,${alpha})`;
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.moveTo(-half, y);
      ctx.lineTo(half, y);
      ctx.stroke();
    }

    for (let i = -7; i <= 7; i += 1) {
      const x = i * 44;
      ctx.strokeStyle = i === 0 ? 'rgba(255,122,26,0.58)' : 'rgba(18,184,176,0.16)';
      ctx.lineWidth = i === 0 ? 2 : 1;
      ctx.beginPath();
      ctx.moveTo(x * 0.1, 0);
      ctx.lineTo(x * 5.2, height * 0.74);
      ctx.stroke();
    }

    ctx.setLineDash([16, 18]);
    ctx.lineDashOffset = reduceMotion ? 0 : -pulse * 48;
    ctx.strokeStyle = 'rgba(255,255,255,0.52)';
    ctx.lineWidth = 3;
    ctx.beginPath();
    ctx.moveTo(0, 24);
    ctx.lineTo(0, height * 0.72);
    ctx.stroke();
    ctx.restore();

    for (let i = 0; i < 26; i += 1) {
      const x = (i * 173 + frame * 0.12) % Math.max(width, 1);
      const y = (i * 97) % Math.max(height * 0.78, 1);
      const size = 1.2 + (i % 4) * 0.6;
      ctx.fillStyle = i % 5 === 0 ? 'rgba(255,122,26,0.34)' : 'rgba(18,184,176,0.3)';
      ctx.beginPath();
      ctx.arc(x, y, size, 0, Math.PI * 2);
      ctx.fill();
    }

    if (!reduceMotion && isVisible && !document.hidden) {
      frame += 1;
      animationFrame = window.requestAnimationFrame(draw);
    }
  };

  const start = () => {
    if (animationFrame || reduceMotion || !isVisible || document.hidden) return;
    animationFrame = window.requestAnimationFrame(() => {
      animationFrame = 0;
      draw();
    });
  };

  const stop = () => {
    if (animationFrame) window.cancelAnimationFrame(animationFrame);
    animationFrame = 0;
  };

  const initialize = () => {
    resize();
    if (reduceMotion) draw();
    const observer = new IntersectionObserver(
      ([entry]) => {
        isVisible = entry.isIntersecting;
        if (isVisible) start();
        else stop();
      },
      { rootMargin: '160px 0px', threshold: 0.01 }
    );
    observer.observe(host);
  };

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(initialize, { timeout: 1200 });
  } else {
    window.setTimeout(initialize, 250);
  }

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) stop();
    else start();
  });

  window.addEventListener(
    'resize',
    () => {
      resize();
      if (reduceMotion) draw();
    },
    { passive: true }
  );
})();
